import { render, staticRenderFns } from "./VueSelectClearable.vue?vue&type=template&id=54513d52&"
import script from "./VueSelectClearable.vue?vue&type=script&lang=js&"
export * from "./VueSelectClearable.vue?vue&type=script&lang=js&"
import style0 from "./VueSelectClearable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports